import {ActivityIndicator, ActivityIndicatorProps} from 'react-native';
import {withTheme} from '@rn-vui/themed';

export default withTheme(ActivityIndicator, 'ActivityIndicator');

declare module '@rn-vui/themed' {
  export interface ComponentTheme {
    ActivityIndicator: Partial<ActivityIndicatorProps>;
  }
}
